import "trix"

document.addEventListener("trix-before-initialize", () => {
  addHeadingAttributes()
  addForegroundColorAttributes()
  addBackgroundColorAttributes()
})
addEventListener("trix-initialize", function (event) {
  new RichText(event.target)
})

addEventListener("trix-action-invoke", function (event) {
  if (event.actionName == "x-horizontal-rule") insertHorizontalRule()

  function insertHorizontalRule() {
    event.target.editor.insertAttachment(buildHorizontalRule())
  }

  function buildHorizontalRule() {
    return new Trix.Attachment({ content: "<hr>", contentType: "vnd.rubyonrails.horizontal-rule.html" })
  }
})

class RichText {
  constructor(element) {
    this.element = element

    this.insertHeadingElements()
  }

  insertHeadingElements() {
    this.removeOriginalHeadingButton()
    this.insertNewHeadingButton()
    this.insertHeadingDialog()
  }

  removeOriginalHeadingButton() {
    this.buttonGroupBlockTools.removeChild(this.originalHeadingButton)
  }

  insertNewHeadingButton() {
    this.buttonGroupBlockTools.insertAdjacentHTML("afterbegin", this.headingButtonTemplate)
  }

  insertHeadingDialog() {
    this.dialogsElement.insertAdjacentHTML("beforeend", this.dialogHeadingTemplate)
  }

  get buttonGroupBlockTools() {
    return this.toolbarElement.querySelector("[data-trix-button-group=block-tools]")
  }

  get buttonGroupTextTools() {
    return this.toolbarElement.querySelector("[data-trix-button-group=text-tools]")
  }

  get dialogsElement() {
    return this.toolbarElement.querySelector("[data-trix-dialogs]")
  }

  get originalHeadingButton() {
    return this.toolbarElement.querySelector("[data-trix-attribute=heading1]")
  }

  get quoteButton() {
    return this.toolbarElement.querySelector("[data-trix-attribute=quote]")
  }

  get toolbarElement() {
    return this.element.toolbarElement
  }

  get headingButtonTemplate() {
    return '<button type="button" class="trix-button trix-button--icon trix-button--icon-heading-1" data-trix-action="x-heading" title="Heading" tabindex="-1">Heading</button>'
  }

  get dialogHeadingTemplate() {
    // <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading1">H1</button>
    // <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading4">H4</button>
    // <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading5">H5</button>
    // <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading6">H6</button>

    return `
      <div class="trix-dialog trix-dialog--heading" data-trix-dialog="x-heading" data-trix-dialog-attribute="x-heading">
        <div class="trix-dialog__link-fields">
          <input type="text" name="x-heading" class="trix-dialog-hidden__input" data-trix-input>
          <div class="trix-button-group">
            <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading2">H2</button>
            <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading3">H3</button>
          </div>
        </div>
      </div>
    `
  }
}

function addHeadingAttributes() {
  Trix.config.blockAttributes.heading2 = {
    tagName: "h2",
    terminal: true,
    breakOnReturn: true
  }
  Trix.config.blockAttributes.heading3 = {
    tagName: "h3",
    terminal: true,
    breakOnReturn: true
  }
}

function addForegroundColorAttributes() {
  Array.from([
    "rgb(136, 118, 38)",
    "rgb(185, 94, 6)",
    "rgb(207, 0, 0)",
    "rgb(216, 28, 170)",
    "rgb(144, 19, 254)",
    "rgb(5, 98, 185)",
    "rgb(17, 138, 15)",
    "rgb(148, 82, 22)",
    "rgb(102, 102, 102)"
  ]).forEach((color, i) => {
    Trix.config.textAttributes[`fgColor${i + 1}`] = { style: { color: color }, inheritable: true, parser: e => e.style.color == color }
  })
}

function addBackgroundColorAttributes() {
  Array.from([
    "rgb(250, 247, 133)",
    "rgb(255, 240, 219)",
    "rgb(255, 229, 229)",
    "rgb(255, 228, 247)",
    "rgb(242, 237, 255)",
    "rgb(225, 239, 252)",
    "rgb(228, 248, 226)",
    "rgb(238, 226, 215)",
    "rgb(242, 242, 242)"
  ]).forEach((color, i) => {
    Trix.config.textAttributes[`bgColor${i + 1}`] = {
      style: { backgroundColor: color },
      inheritable: true,
      parser: e => e.style.backgroundColor == color
    }
  })
}
